import React, { FC, useEffect, useState } from 'react'
import { IImageTickerItem } from '../../types'
import styles from './ImageTicker.module.scss'
import cx from 'classnames'
import { useInView } from 'react-intersection-observer'
import { ImageTickerItem } from './ImageTickerItem'

export const ImageTicker: FC<{
  items: IImageTickerItem[]
  isBig?: boolean
  className?: string
  showMobile?: boolean
}> = ({ items, isBig, className, showMobile }) => {
  if (items?.length < 1) {
    return null
  }

  const { ref, inView } = useInView({ triggerOnce: true })
  const [animated, setAnimated] = useState(false)

  useEffect(() => {
    if (inView) {
      setTimeout(() => {
        setAnimated(true)
      }, 500)
    }
  }, [inView])

  const getItems = (key: string) => {
    return items?.map((img) => (
      <li key={`${img.id}-${key}`} className={cx(showMobile && styles.desk)}>
        <ImageTickerItem img={img} />
      </li>
    ))
  }

  const getMobileItems = (key: string) => {
    return items
      .filter((img) => img.imgMobile)
      ?.map((img) => (
        <li key={`${img.id}-${key}`} className={styles.mobile}>
          <ImageTickerItem
            img={{ ...img, img: img.imgMobile }}
            width={60}
            height={60}
          />
        </li>
      ))
  }

  return (
    <div ref={ref} className={cx(className, styles.wrapper)}>
      {Array.from({ length: 5 }, (_, index) => (
        <ul
          key={`list-${index}`}
          className={cx(
            styles.list,
            isBig && styles.big,
            animated && styles.animated,
            showMobile && styles.showMobile,
          )}
        >
          {getItems(`copy-${index + 1}`)}
          {showMobile && getMobileItems(`mobile-copy-${index + 1}`)}
        </ul>
      ))}
    </div>
  )
}
